var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { baseClientDefaults } from '@juvare/platform-sdk-js/BaseClient';
import { alertPrefix } from '../../../clients/AlertServiceClient';
import ContextClient from '../../../clients/ContextClient';
export function buildOwnersValueProvider() {
    return {
        type: 'alerts.owners',
        label: 'Owners',
        getValues: () => __awaiter(this, void 0, void 0, function* () {
            const contextClient = new ContextClient(baseClientDefaults.baseUrl + alertPrefix + '/api');
            return (yield contextClient.getOwners()).map((owner) => ({ value: owner.externalId, label: owner.name }));
        }),
    };
}
